import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, Popconfirm} from 'antd';
import {Route, Switch} from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {
    createResource,
    deleteResource,
    fetchResource,
    getResource,
    getResourceForDownload,
    saveResourceQuery,
    updateResource
} from "../../appRedux/actions/Client";
import {fetchFilter, fetchSubDocumentFilter} from '../../appRedux/actions';
import {
    faviconDynamicFunction,
    getColumnSearchProps,
    getRenderForFieldByType,
    sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';

export class Roles extends Component {
    initialQueryState = {
        sort: {
            field: '',
            order: ''
        },
        pagination: {
            pageSize: 10,
            current: 1
        },
        filters: {},
    };

    state = {
        fields: {
            name: {
                value: '',
            },
            description: {
                value: ''
            }
        },
        query: this.initialQueryState,
        columns: [],
        visibleColumns: []
    };

    constructor(props) {
        super(props);
        props.saveResourceQuery(this.initialQueryState);
    }

    componentDidMount() {
        this.fetchList();
        this.props.fetchFilter(this.props.resourceName);
        this.props.fetchSubDocumentFilter('Document');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
            const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
            this.setState({
                visibleColumns: columns
            }, () => {
                this.renderColumns(nextProps.filters, this.state.visibleColumns);
            })
        }
    }

    handleColumnChange = (value, array) => {
        const {filters} = this.props;
        this.renderColumns(filters, value);
    };

    handleFilter = (selectedKeys, confirm, data) => {
        const query = {...this.props.query};
        query.filters[data.field] = JSON.stringify({
            value: selectedKeys,
            type: data.type,
            field: data.field
        });
        this.props.saveResourceQuery(query);
        confirm();
        this.fetchList();
    };

    handleReset = (clearFilters, data) => {
        const query = {...this.props.query};
        delete query.filters[data.field];
        this.props.saveResourceQuery(query);
        clearFilters();
        this.fetchList();
    };

    handleChange = (pagination, filters, sorter) => {
        const query = {...this.props.query};
        query.pagination = {...query.pagination, current: pagination.current};
        query.sort = sorter;

        this.props.saveResourceQuery(query);
        this.fetchList();
    };

    handleFormChange = (changedFields) => {
        this.setState(({fields}) => ({
            fields: {...fields, ...changedFields},
        }));
    };

    renderColumns = (filters, selectedColumns) => {
        filters = filters || this.props.filters;
        const columns = [];
        const {resourceName} = this.props;

        Object.keys(filters).forEach((item) => {

            if (item === '_id') {
                return;
            }

            if (selectedColumns.indexOf(item) === -1) {
                return;
            }

            columns.push({
                title: sanitizeFieldName(item),
                dataIndex: filters[item].field,
                sorter: true,
                render: (value) => getRenderForFieldByType(value, filters[item].type, item),
                ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
            })
        });

        columns.push({
            title: 'Action',
            key: 'action',
            render: (record) => (
                <div>
                    <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                                   roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                        return <Button disabled={!!(record && record.isSystemGenerated)} type="primary" size='small'
                                       onClick={() => this.edit(record._id)}>Edit</Button>
                    }}/>

                    <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                                   roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
                        return <Popconfirm
                            title="Are you sure you want to delete this record?"
                            onConfirm={() => {
                                this.deleteResource(record._id)
                            }}
                            onCancel={this.cancelDelete}
                            okText="Yes"
                            cancelText="No"
                            disabled={!!(record && record.isSystemGenerated)}
                        >
                            <Button disabled={!!(record && record.isSystemGenerated)} style={{marginLeft: '10px'}}
                                    type="danger" size='small'>Delete</Button>
                        </Popconfirm>
                    }}/>

                </div>
            ),
        });

        this.setState({
            visibleColumns: selectedColumns,
            columns
        })
    };

    // clearAll = () => {
    //   this.props.saveResourceQuery(this.initialQueryState);
    //   this.fetchList();
    // };

    clearAll = () => {
        const clearQueryState = {
            sort: {
                field: '',
                order: ''
            },
            pagination: {
                pageSize: 10,
                current: 1
            },
            filters: {},
        };
        //this.props.saveResourceQuery(this.initialQueryState);
        this.props.saveResourceQuery(clearQueryState);
        this.fetchList();
    };

    fetchList = () => {
        this.props.getResource();
    };

    createResource = (values) => {
        values.documents = values.documents || [];
        this.props.createResource(values);
    };

    updateResource = (values, id) => {
        values.documents = values.documents || [];
        this.props.updateResource(values, id);
    };

    deleteResource = (id) => {
        this.props.deleteResource(id);
    };

    cancelDelete = () => {
        message.error('Cancelled')
    };

    create = () => {
        const {match} = this.props;
        this.props.history.push(`${match.url}/add`);
    };

    edit = (id) => {
        const {match} = this.props;
        this.props.history.push(`${match.url}/edit/${id}`);
    };

    downloadToCSV = () => {
        const columns = [];
        this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
        this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "SubLocation");
    }

    render() {
        const {
            match,
            data,
            resource,
            edit,
            fetchResource,
            loading,
            filters,
            modules,
            authUser,
            resourceName
        } = this.props;
        const {columns, visibleColumns} = this.state;
        faviconDynamicFunction(authUser);

        return (<div>
            <h2>Sub Location</h2>

            <Switch>
                <Route path={`${match.url}`} exact
                       render={() => <List columns={columns}
                                           data={data}
                                           clearFilter={this.clearAll}
                                           filters={filters}
                                           handleChange={this.handleChange}
                                           columnChange={this.handleColumnChange}
                                           downloadToCSV={this.downloadToCSV}
                                           title={resourceName}
                                           size={'middle'}
                                           create={this.create}
                                           pagination={this.props.query.pagination}
                                           loading={loading}
                                           authUser={authUser}
                                           visibleColumn={visibleColumns}
                       />
                       }/>
                <Route path={`${match.url}/add`}
                       render={(props) => <Create data={{}}
                                                  filters={filters}
                                                  subDocumentFilters={this.props.subDocumentFilters}
                                                  modules={modules}
                                                  title={'CREATE'}
                                                  resource={resourceName}
                                                  onChange={this.handleFormChange}
                                                  onSubmit={this.createResource}
                                                  loading={loading}
                                                  {...props}
                       />
                       }/>
                <Route path={`${match.url}/edit/:id`}
                       render={(props) => <Create data={edit}
                                                  filters={filters}
                                                  modules={modules}
                                                  title={'EDIT'}
                                                  resource={resourceName}
                                                  fetch={fetchResource}
                                                  onChange={this.handleFormChange}
                                                  onSubmit={this.updateResource}
                                                  loading={loading}
                                                  {...props}
                       />
                       }/>
            </Switch>
        </div>)
    }
}

const mapStateToProps = ({auth, client, commonData}) => {
    return {
        authUser: auth.authUser,
        total: client.total,
        data: client.resources,
        resource: client.resource,
        edit: client.edit,
        query: client.query,
        loading: commonData.loading,
        filters: commonData.filters,
        modules: commonData.modules,
        subDocumentFilters: commonData.subDocumentFilters
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getResource,
        getResourceForDownload,
        createResource,
        fetchResource,
        updateResource,
        deleteResource,
        saveResourceQuery,
        fetchFilter,
        fetchSubDocumentFilter
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Roles);
